import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { SaveIndicator } from 'apps/sigma2-ui/src/components/SaveIndicator';
import { useDatabasesEditPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDatabasesEditPage';
import { useParams } from 'react-router';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';

export const DatabasesEditPage = () => {
  const {
    nameLabel,
    name,
    setName,
    description,
    descriptionLabel,
    setDescription,
    submitButtonLabel,
    submitButtonDisabled,
    submitButtonBehavior,
    backButtonLabel,
    backButtonDisabled,
    backButtonBehavior,
    saveIndicatorStatus,
    viewRevisionsButtonDisabled,
    viewRevisionsButtonBehavior,
    viewRevisionsButtonLabel,
  } = useDatabasesEditPage();

  const { organizationId, databaseId } = useParams();

  if (!organizationId || !databaseId) {
    throw new Error('organizationId and databaseId are required');
  }

  return (
    <AdminLayout currentPage={'DatabasesEdit'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'Edit Database',
            to: `/organizations/${organizationId}/databases/edit/${databaseId}`,
          },
        ]}
      />
      <Spacing size={'md'} direction={'vertical'}>
        <Paragraph>
          You can edit your database here. Please provide a name.
        </Paragraph>

        <div>
          <SimpleInput label={nameLabel} value={name} onChange={setName} />
        </div>

        <div>
          <SimpleInput
            label={descriptionLabel}
            value={description}
            onChange={setDescription}
          />
        </div>

        <Spacing size={'md'} direction={'horizontal'}>
          <Button
            behavior={backButtonBehavior}
            text={backButtonLabel}
            disabled={backButtonDisabled}
          />

          <Button
            behavior={submitButtonBehavior}
            text={submitButtonLabel}
            disabled={submitButtonDisabled}
          />

          <Button
            behavior={viewRevisionsButtonBehavior}
            text={viewRevisionsButtonLabel}
            disabled={viewRevisionsButtonDisabled}
            className={'self-end'}
          />

          <Button
            behavior={{
              type: 'href',
              href: `/organizations/${organizationId}/databases/${databaseId}/schedules`,
            }}
            text={'Schedules'}
          />

          <Button
            behavior={{
              type: 'href',
              href: `/organizations/${organizationId}/databases/${databaseId}/rubric-bank`,
            }}
            text={'Rubric Bank'}
          />

          <Button
            behavior={{
              type: 'href',
              href: `/organizations/${organizationId}/databases/${databaseId}/merge-realtime-writeback-configs`,
            }}
            text={'Merge Realtime Writeback Configs'}
          />

          <Button
            behavior={{
              type: 'href',
              href: `/organizations/${organizationId}/databases/${databaseId}/feature-flags`,
            }}
            text={'Feature Flags'}
          />

          <SaveIndicator status={saveIndicatorStatus} />
        </Spacing>
      </Spacing>
    </AdminLayout>
  );
};
